import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { FirmwareOverviewDto } from '../../../features/firmware-management/dtos/firmware-overview.dto';
import { FirmwareFilters } from '../../../features/firmware-management/models/firmware-filters.model';
import { mapFirmwareOverviewDtoToFirmwareOverviewModel } from '../../../features/firmware-management/utils/mapping/mapping.util';
import { axiosInstance } from '../../../features/shared/api/axios-instance';
import { createQueryParams } from '../../../features/shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../../features/shared/utils/endpoints-file.utils';
import { FirmwareOverviewModel } from '../../models/firmware-overview.model';
import { withMandant } from '../with-mandant/with-mandant.thunk';

export const getFirmwares: AsyncThunk<
  FirmwareOverviewModel[],
  Partial<FirmwareFilters> | undefined,
  Record<string, unknown>
> = withMandant<Partial<FirmwareFilters> | undefined, FirmwareOverviewModel[]>(
  Endpoints.FIRMWARE_BY_MANDANT_ID,
  'firmware/get-firmwares',

  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      ...args,
    });

    const { data }: AxiosResponse<FirmwareOverviewDto[]> =
      await axiosInstance.get(endpoint + queryParams);

    return data.map(mapFirmwareOverviewDtoToFirmwareOverviewModel);
  }
);
